import {
  AggregationType,
  ChartType,
} from '@/features/charts/components/create-chart-type-selection';
import { supabase } from '@/lib/supabase';

export interface UpdateChartData {
  chartType: ChartType;
  aggregationType: AggregationType;
  kpiIds: number[];
}

export const updateChart = async ({
  chartId,
  chartData,
}: {
  chartId: number;
  chartData: UpdateChartData;
}): Promise<void> => {
  const { error } = await supabase.rpc('update_chart_config', {
    p_chart_id: chartId,
    p_chart_type: chartData.chartType,
    p_aggregation_type: chartData.aggregationType,
    p_config_type: chartData.chartType,
    p_kpi_ids: chartData.kpiIds,
  });

  if (error) {
    throw error;
  }
};
